import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1574.51294,138.514824 C1544.13176,108.246588 1507.76471,86.6748235 1468.23529,72.896 L1468.23529,507.832471 L1903.17176,507.832471 C1889.39294,468.303059 1867.93412,431.936 1837.55294,401.667765 L1574.51294,138.514824 Z M1355.29412,620.705882 L1355.29412,56 L451.764706,56 L451.764706,959.529412 L0,959.529412 L0,1072.47059 L451.764706,1072.47059 L451.764706,1863.05882 L1920,1863.05882 L1920,620.705882 L1355.29412,620.705882 Z M887.04,1425.29882 L807.190588,1345.44941 L1080.05647,1072.47059 L564.705882,1072.47059 L564.705882,959.529412 L1080.05647,959.529412 L807.190588,686.663529 L887.04,606.814118 L1296.22588,1016 L887.04,1425.29882 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSisImportedSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconSisImportedSolid, _Component);

  var _super = _createSuper(IconSisImportedSolid);

  function IconSisImportedSolid() {
    _classCallCheck(this, IconSisImportedSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconSisImportedSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSisImported",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconSisImportedSolid.displayName = "IconSisImportedSolid";
  return IconSisImportedSolid;
}(Component);

IconSisImportedSolid.glyphName = 'sis-imported';
IconSisImportedSolid.variant = 'Solid';
IconSisImportedSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSisImportedSolid;
export { IconSisImportedSolid };